import styled from '@xstyled/styled-components';
export const ScreenContainer = styled.box.withConfig({
  displayName: "ScreenContainer",
  componentId: "sc-cql6od-0"
})(["width:100%;max-width:screen;margin:0 auto;padding-left:3;padding-right:3;"]);